import { SupabaseClient } from "@supabase/supabase-js";

/**
 * Checks if the user is whitelisted.
 *
 * @param supabase - The Supabase client
 * @param email - The email of the user
 * @returns True if the user is whitelisted, false otherwise
 * @throws An error if there is an issue fetching the whitelisted user
 */
export async function isUserEmailWhitelisted(supabase: SupabaseClient, email: string): Promise<boolean> {
  const { data, error } = await supabase
    .schema("nowadays")
    .from("whitelisted_users")
    .select("*")
    .eq("email", email)
    .maybeSingle();

  if (error) {
    throw new Error(`Error fetching whitelisted user: ${error.message}`);
  }

  return !!data;
}
